const isValidWebkitEnvironment = () => typeof MobileWebKit !== 'undefined' && typeof MobileWebKit.executeNative === 'function' && typeof MobileWebKit.events !== 'undefined' && typeof MobileWebKit.events.subscribeMethod === 'function' && typeof MobileWebKit.events.unsubscribe === 'function';
const isWebkit2 = () => {
  var _MobileWebKit, _MobileWebKit2;
  return isValidWebkitEnvironment() && ((_MobileWebKit = MobileWebKit) === null || _MobileWebKit === void 0 ? void 0 : _MobileWebKit.engine) === ((_MobileWebKit2 = MobileWebKit) === null || _MobileWebKit2 === void 0 || (_MobileWebKit2 = _MobileWebKit2.Engines) === null || _MobileWebKit2 === void 0 ? void 0 : _MobileWebKit2.V200);
};
const disableWebviewTopbar = _ref => {
  var _MobileWebKit3, _MobileWebKit4;
  let {
    onBack,
    opacity = 0.8,
    animated = true,
    duration = 200
  } = _ref;
  if (!isWebkit2()) return;
  (_MobileWebKit3 = MobileWebKit) === null || _MobileWebKit3 === void 0 || _MobileWebKit3.topbar.disable({
    opacity,
    animated,
    duration
  }).catch(() => {});
  const backActionSubscriptionId = (_MobileWebKit4 = MobileWebKit) === null || _MobileWebKit4 === void 0 ? void 0 : _MobileWebKit4.navigation.subscribeToBackAction(onBack);
  return {
    backActionSubscriptionId
  };
};
const enableWebviewTopbar = function () {
  var _MobileWebKit5;
  let {
    animated = true,
    duration = 200,
    subscriptionIds
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!isWebkit2()) return;
  (_MobileWebKit5 = MobileWebKit) === null || _MobileWebKit5 === void 0 || _MobileWebKit5.topbar.enable({
    animated,
    duration
  }).catch(() => {});
  if (subscriptionIds !== null && subscriptionIds !== void 0 && subscriptionIds.backActionSubscriptionId) {
    var _MobileWebKit6;
    (_MobileWebKit6 = MobileWebKit) === null || _MobileWebKit6 === void 0 || _MobileWebKit6.navigation.unsubscribeToBackAction(subscriptionIds.backActionSubscriptionId).catch(() => {});
  }
};
const hideWebviewTopbar = _ref2 => {
  var _MobileWebKit7, _MobileWebKit9;
  let {
    onBack,
    animated = true,
    duration: animation_duration = 350
  } = _ref2;
  if (!isWebkit2()) return;
  if (typeof ((_MobileWebKit7 = MobileWebKit) === null || _MobileWebKit7 === void 0 || (_MobileWebKit7 = _MobileWebKit7.topbar) === null || _MobileWebKit7 === void 0 ? void 0 : _MobileWebKit7.fullScreenMode) === 'function') {
    MobileWebKit.topbar.fullScreenMode(true, {
      animated,
      animation_duration
    }).catch(() => {});
  } else {
    var _MobileWebKit8;
    (_MobileWebKit8 = MobileWebKit) === null || _MobileWebKit8 === void 0 || _MobileWebKit8.topbar.disable({
      opacity: 0.8,
      animated,
      duration: 200
    }).catch(() => {});
  }
  const backActionSubscriptionId = (_MobileWebKit9 = MobileWebKit) === null || _MobileWebKit9 === void 0 ? void 0 : _MobileWebKit9.navigation.subscribeToBackAction(onBack);
  return {
    backActionSubscriptionId
  };
};
const showWebviewTopbar = function () {
  var _MobileWebKit10;
  let {
    animated = true,
    duration: animation_duration = 350,
    subscriptionIds
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!isWebkit2()) return;
  if (typeof ((_MobileWebKit10 = MobileWebKit) === null || _MobileWebKit10 === void 0 || (_MobileWebKit10 = _MobileWebKit10.topbar) === null || _MobileWebKit10 === void 0 ? void 0 : _MobileWebKit10.fullScreenMode) === 'function') {
    MobileWebKit.topbar.fullScreenMode(false, {
      animated,
      animation_duration
    }).catch(() => {});
  } else {
    var _MobileWebKit11;
    (_MobileWebKit11 = MobileWebKit) === null || _MobileWebKit11 === void 0 || _MobileWebKit11.topbar.enable({
      animated,
      duration: 200
    }).catch(() => {});
  }
  if (subscriptionIds !== null && subscriptionIds !== void 0 && subscriptionIds.backActionSubscriptionId) {
    var _MobileWebKit12;
    (_MobileWebKit12 = MobileWebKit) === null || _MobileWebKit12 === void 0 || _MobileWebKit12.navigation.unsubscribeToBackAction(subscriptionIds.backActionSubscriptionId).catch(() => {});
  }
};
export { disableWebviewTopbar, enableWebviewTopbar, hideWebviewTopbar, showWebviewTopbar };
